import React from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import toast from "react-hot-toast";
import { FaGift } from "react-icons/fa";

import { UserService } from "_services";
import Emitter from "_actions/emitter";
import { getCurrency } from "components/Navbar/NavUserBox";
import i18n from "i18n";
import RequestsPage from "./RequestsPage";

const EXTRA_COLUMNS = (t) => [
  {
    header: t("BONUS_REQUEST_MESSAGE_COLUMN"),
    render: (item) => item.Message || "—",
    mobileRender: (item) => item.Message,
  },
];

const BonusRequests = (props) => {
  const [requests, setRequests] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [cancellingId, setCancellingId] = React.useState(null);

  const userInfo = { ...props.user, ...props.user?.RelUser };
  const currency = getCurrency(userInfo.Currency);

  const loadRequests = () => {
    setLoading(true);
    UserService.GET_MY_BONUS_REQUESTS()
      .then((res) => {
        setRequests(res || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    loadRequests();
  }, []);

  React.useEffect(() => {
    Emitter.on("BONUS_REQUEST_CREATED", loadRequests);
    return () => {
      Emitter.off("BONUS_REQUEST_CREATED");
    };
  }, []);

  const handleCancel = (requestId) => {
    setCancellingId(requestId);
    UserService.CANCEL_BONUS_REQUEST(requestId)
      .then(() => {
        setCancellingId(null);
        loadRequests();
      })
      .catch((err) => {
        setCancellingId(null);
        const failText = err?.response?.data?.failText?.[0];
        toast.error(failText || i18n.t("BONUS_REQUEST_CANCEL_ERROR"));
      });
  };

  return (
    <Translation>
      {(t) => (
        <RequestsPage
          t={t}
          icon={FaGift}
          title={t("NAV_TITLE_BONUS_REQUESTS")}
          subtitle={t("BONUS_REQUEST_MODAL_SUBTITLE")}
          requests={requests}
          loading={loading}
          currency={currency}
          cancellingId={cancellingId}
          onCancel={handleCancel}
          onNewRequest={() => Emitter.emit("BONUS_REQUEST_MODAL", true)}
          newButtonLabel={t("BONUS_REQUEST_NEW_BUTTON")}
          noDataLabel={t("BONUS_REQUEST_NO_DATA")}
          cancelButtonLabel={t("BONUS_REQUEST_CANCEL_BUTTON")}
          cancelConfirmLabel={t("BONUS_REQUEST_CANCEL_CONFIRM")}
          statusPrefix="BONUS_REQUEST_STATUS_"
          getAmount={(item) => item.SuggestedAmount}
          extraColumns={EXTRA_COLUMNS(t)}
        />
      )}
    </Translation>
  );
};

const mapStateToProps = (state) => {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user,
  };
};

export default connect(mapStateToProps)(BonusRequests);
